import { AlertManager } from 'react-alert'

export interface RouterProps {
  alert?: AlertManager
}

export enum MyStorePaths {
  ROOT = '/my-store',
  ROOT_BY_STORE = '/my-store/:storeId(\\d+)',
  STORES = '/stores',
  STOREVIEW = '/stores/:storeId',
  PRODUCTS = '/my-store/products',
  PRODUCTS_BY_STORE = '/my-store/:storeId(\\d+)/products',
  PRODUCT = '/product/:productId',
  ORDERS = '/my-store/orders',
  DEPARTMENTS = '/departments',
  DEPARTMENT_CATEGORY = '/departments/:departmentId',
  DEPARTMENT_CATEGORY_FILTER = '/departments/:departmentId/category/:categoryId',
  PRODUCT_VIEW = '/my-store/products/:productId',
  PRODUCT_VIEW_BY_STORE = '/my-store/:storeId(\\d+)/products/:productId',
  PRODUCT_ADD = '/my-store/products/add-new',
  PRODUCT_ADD_BY_STORE = '/my-store/:storeId(\\d+)/products/add-new',
  ACCOUNT_DETAILS = '/account/details',
  ACCOUNT_ORDERS = '/account/orders',
  ACCOUNT_ADDRESSES = '/account/address',
  ACCOUNT_PAYMENT = '/account/payment',
  ACTION_HISTORY = '/action-history',
  CART = '/cart',
  CHECKOUT = '/checkout',
  STATISTICS = '/statistics',
  STATISTICS_BY_STORE = '/my-store/:storeId(\\d+)/statistics',
  TERMS = '/terms'
}

export const getMyStorePath = (storeId?: number | string): string =>
  storeId ? `/my-store/${storeId}` : MyStorePaths.ROOT

export const getMyStoreProductsPath = (storeId?: number | string): string =>
  storeId ? `/my-store/${storeId}/products` : MyStorePaths.PRODUCTS

export const getMyStoreProductAddPath = (storeId?: number | string): string =>
  storeId ? `/my-store/${storeId}/products/add-new` : MyStorePaths.PRODUCT_ADD

export const getMyStoreProductViewPath = (
  productId: number | string,
  storeId?: number | string
): string =>
  storeId
    ? `/my-store/${storeId}/products/${productId}`
    : `/my-store/products/${productId}`

export const getMyStoreStatisticsPath = (storeId?: number | string): string =>
  storeId ? `/my-store/${storeId}/statistics` : MyStorePaths.STATISTICS
